import React, { Component } from 'react';
class Balloon extends Component {
    render () {
        return (
            <div className='speech-wrapper'>
                <div className='bubble'>
                    <div className='txt'>
                        <p className='name'>{this.props.name}</p>
                        <p className='message'>{this.props.message}</p>
                    </div>
                    <div className='bubble-arrow' />
                </div>
            </div>
        );
    }
}

export default Balloon;



// WEBPACK FOOTER //
// ./src/views/components/chatBalloon.js